import OpenApp from "./OpenApp";

export default OpenApp;